const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyLiquidateSmallIconIi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#181A1E",
    style: {
      fill: "#181A1E",
      fill: "color(display-p3 0.0941 0.1020 0.1176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8396 21.7965C33.2192 21.7965 33.533 22.0787 33.5827 22.4447L33.5896 22.5465V36.1643C33.5896 36.5785 33.2538 36.9143 32.8396 36.9143C32.4599 36.9143 32.1461 36.6321 32.0964 36.2661L32.0896 36.1643V22.5465C32.0896 22.1323 32.4253 21.7965 32.8396 21.7965Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3857 31.539C36.6779 31.2454 37.1528 31.2443 37.4463 31.5366C37.7132 31.8022 37.7384 32.2188 37.5212 32.5129L37.4488 32.5972L33.371 36.6939C33.1045 36.9616 32.6862 36.986 32.3921 36.7669L32.3079 36.6939L28.2301 32.5972C27.9379 32.3036 27.939 31.8288 28.2326 31.5366C28.4994 31.2709 28.9162 31.2477 29.2093 31.4662L29.2932 31.539L32.839 35.101L36.3857 31.539Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3585 19.2303C23.0644 19.0112 22.6462 19.0355 22.3797 19.3033L18.3019 23.4L18.2295 23.4842C18.0123 23.7784 18.0375 24.195 18.3043 24.4606L18.3886 24.533C18.6827 24.7502 19.0993 24.725 19.365 24.4582L22.1611 21.6486V33.4508L22.1679 33.5526C22.2176 33.9186 22.5314 34.2008 22.9111 34.2008C23.3253 34.2008 23.6611 33.865 23.6611 33.4508V21.6487L26.4574 24.4582L26.5414 24.531C26.8345 24.7495 27.2512 24.7263 27.5181 24.4606C27.8117 24.1684 27.8128 23.6935 27.5206 23.4L23.4428 19.3033L23.4369 19.2982C23.4144 19.2761 23.3906 19.2554 23.3655 19.2363L23.3585 19.2303Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLiquidateSmallIconIi);
export default __webpack_public_path__ + "static/media/why-liquidate-small-icon-ii.578350d983f6193dc5e5670931ebf778.svg";
export { ForwardRef as ReactComponent };